const _selector = '.logotypes-carousel';

const options = {
    loop: true,
    dots: false,
    nav: true,
    autoplay: true,
    navText: [
        $('<img src="/assets/icons/owl-arrow-left.svg" alt="prev">'),
        $('<img src="/assets/icons/owl-arrow-right.svg" alt="next">')
    ],
    responsiveClass: true,
    responsive: {
        0: {
            items: 2
        },
        768: {
            items: 3
        },
        992: {
            items: 4
        },
        1200: {
            items: 5
        }
    }
};

export function init() {
    let carousel = $(_selector);

    if (carousel.length > 0) {
        carousel.owlCarousel(options);
    }
}
